import { $country, $region, getCountry, getLanguageIso2, getRegion, setI18nUserSelection } from '../modules/i18n';
import type { IRegionSelectOverlay } from '@bjb/bjb-web-components/dist/components/jb-region-select-overlay/jb-region-select-overlay.custom';

void getRegion();
void getCountry();

document.addEventListener('jb-region-select-overlay:connected', (event: Event) => {
  const { element } = (event as CustomEvent<{ element: IRegionSelectOverlay }>).detail;

  $region.subscribe((region) => { element.preselectedRegion = region || undefined; });
  $country.subscribe((country) => { element.preselectedCountry = country || undefined; });

  getLanguageIso2().then((languageIso2) => {
    element.preselectedLanguageIso2 = languageIso2 || undefined;
  });
});

document.addEventListener('jb-region-select-overlay:selection-confirmed', (event: Event) => {
  setI18nUserSelection((event as CustomEvent).detail);
});
